import api from './api';

export const getTasks = (params = {}) =>
  api.get('/tasks', { params }).then((r) => r.data);

export const getTaskCount = () =>
  api.get('/tasks/count').then((r) => r.data);

export const createTask = (data) =>
  api.post('/tasks', data).then((r) => r.data);

export const completeTask = (id) =>
  api.patch(`/tasks/${id}/complete`).then((r) => r.data);

export const dismissTask = (id) =>
  api.patch(`/tasks/${id}/dismiss`).then((r) => r.data);

export const deleteTask = (id) =>
  api.delete(`/tasks/${id}`).then((r) => r.data);
